{
  "type": "object",
  "patternProperties": {
    "^.+$": { "$ref": "common_definitions.json#/definitions/ColumnDescription" }
  },
  "properties": {
    "StimulusPresentation": {
      "type": "object",
      "properties": {
        "OperatingSystem": {
          "type": "string"
        },
        "SoftwareName": {
          "type": "string"
        },
        "SoftwareRRID": {
          "type": "string",
          "pattern": ".+_.+"
        },
        "SoftwareVersion": {
          "type": "string"
        },
        "Code": {
          "type": "string",
          "format": "uri"
        }
      }
    }
  }
}
